<div class="score-bar">
    @if (score !== null && score !== undefined){
        <span>{{ score.toFixed(0) }}%</span>
        <div class="score-container">
            <div class="score-cover" [ngClass]="class" [ngStyle]="{'width': score + '%'}"></div>
         </div> 
    }
</div>